import { createSelector } from '@reduxjs/toolkit';

const getRootEntity = ({ retailersGroupsTitles }) => {
  return retailersGroupsTitles;
};

export const getGroupTitles = createSelector(getRootEntity, titles => {
  return titles.titles;
});

export const getLoaded = createSelector(getRootEntity, titles => {
  return titles.loaded;
});

export const getMarketingCopy = createSelector(getRootEntity, titles => {
  return titles.marketingCopy;
});
